export const SCRIPT_ID = 'script-teads-pixel';
export const SCRIPT_SRC = 'https://p.teads.tv/teads-fellow.js';
export const TEADS_BUYER_PIXEL_ID = 13445;
export const TEADS_PIXEL_VENDOR_ID = 'teads';
